import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import API from '../../../services/API'
import Stack from '@mui/material/Stack'
import SplitPage from '../../../components/SplitPage/SplitPage'
import Loading, { LoadingSmall } from '../../loading/loadingPage'
import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material'

const useQuery = () => {
  const { search } = useLocation()
  return React.useMemo(() => new URLSearchParams(search), [search])
}
const VerifyEmail = () => {
  const token = useQuery().get('token')
  const [loading, setLoading] = useState(false)
  const [verified, setVerified] = useState(false)
  const [tokenExpired, setTokenExpired] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    API.post('/verify-email', { token })
      .then((res) => {
        if (res.status === 200) {
          setVerified(true)
          setLoading(false)
        } else setTokenExpired(true)
      })
      .catch((e) => console.log(e))
  }, [])

  return (
    <SplitPage>
      {loading ? (
        <Loading />
      ) : verified ? (
        <Alert severity="success">
          <AlertTitle>Account Verified</AlertTitle>
          <Stack>
            <Typography>
              Your account has been successfully verified. You can now login.
            </Typography>
            <Button
              onClick={() => navigate('/')}
              variant="contained"
              sx={{ marginTop: 2 }}
            >
              Login
            </Button>
          </Stack>
        </Alert>
      ) : (
        tokenExpired && (
          <Stack gap={2}>
            <Alert severity="error">This token has expired.</Alert>
            <Button onClick={() => navigate('/')} variant='contained'>Return Home</Button>
          </Stack>
        )
      )}
    </SplitPage>
  )
}

export default VerifyEmail
